export default function commands(
  state = {
    snapCommands: [],
    pythonCommands: [],
    selectedCommand: null,
  },
  action
) {
  switch (action.type) {
    case 'RECEIVE_COMMAND':
      return {
        ...state,
        selectedCommand: action.command,
      };
    case 'RECEIVE_COMMANDS':
      return {
        ...state,
        snapCommands: action.commands.filter(command => command.snap !== null),
        pythonCommands: action.commands.filter(
          command => command.python !== null
        ),
      };
    default:
      return state;
  }
}
